import { Sparkles, Lock } from "lucide-react";
import { useBetaState } from "@/hooks/useBetaState";

type Props = {
  variant?: "compact" | "hero";
  className?: string;
};

/**
 * Beta seat counter shown on marketing/auth pages while the
 * launch beta is active. Hidden entirely once the toggle is off.
 */
export function BetaBanner({ variant = "compact", className }: Props) {
  const { enabled, remaining, cap, loading } = useBetaState();

  if (loading || !enabled) return null;

  const closed = remaining <= 0;
  const Icon = closed ? Lock : Sparkles;

  const base =
    "inline-flex items-center gap-2 rounded-full border border-primary/30 bg-primary/5 px-3 py-1.5 text-sm text-primary";
  const heroExtras = variant === "hero" ? "shadow-soft" : "";

  return (
    <div className={[base, heroExtras, className ?? ""].join(" ").trim()} role="status" aria-live="polite">
      <Icon className="h-4 w-4" aria-hidden />
      {closed ? (
        <span>
          Beta is full — signups paused at {cap} accounts. Join the waitlist soon.
        </span>
      ) : (
        <span>
          Launch beta · <strong className="font-semibold">{remaining}</strong> of {cap} seats left
        </span>
      )}
    </div>
  );
}
